import {Injectable} from '@angular/core';
import {ReplaySubject} from "rxjs";
import {Student} from "@tva/ng-migration/student/models/student.model";

@Injectable({
  providedIn: 'root'
})
export class SearchDetailsNotificationService {
    studentObservable: ReplaySubject<Student> = new ReplaySubject(1);

    constructor() { }

    selectStudent(student: Student): void {
        this.studentObservable.next( student);
    }
}

